
export const OFFER_RESPONSE_STATUS = {
    Unknown: 0,
    Pending: 1,
    Sent: 2,
    MissingResume: 3,
    ToFinalize: 4,
    SmartApplyToFinalize: 5,
    SmartApplyExistingAccount: 6,
    SmartApplyExpiredOffer: 7,
    SmartApplyAlreadyApplied: 8,
    SeenByRecruiter: 9,
    RejectedByRecruiter: 10,
    Error: 11,
    AtsUnknownError: 12,
    AtsApplicationExists: 13,
    AtsAuthError: 14,
    AtsAttachmentError: 15,
    AtsOfferError: 16,
    AtsBodyError: 17,
    AtsConfigError: 18,
    AtsFieldSizeError: 19,
    AtsExternalError: 20,
    ErrorMarvin: 21,
    PlannedInterviewByRecruiter: 22,
    HiredByRecruiter: 23,
    PlannedPhoneInterviewByRecruiter: 24
  }


export const isDisabledStatus = (status: number): boolean => {
  return [
    OFFER_RESPONSE_STATUS.Pending,
    OFFER_RESPONSE_STATUS.MissingResume,
    OFFER_RESPONSE_STATUS.ToFinalize,
    OFFER_RESPONSE_STATUS.SmartApplyToFinalize,
    OFFER_RESPONSE_STATUS.SmartApplyExistingAccount,
    OFFER_RESPONSE_STATUS.ErrorMarvin].includes(status);
}

export interface MetaStatus {
  label: string
  id: number
  color: string
}

export interface CandidateResponseType {
  label: string
  id: number
  tracking: {
    name: string 
    info: string
  }
}

export const CANDIDATE_RESPONSE_TYPE = [
  { label: 'HaveYouFinalized_Yes,', id: 0, tracking: { name: 'application_status_finalised', info: 'yes'}},
  { label: 'HaveYouFinalized_NotYet,', id: 0, tracking: { name: 'application_status_finalised', info: 'no'}},
  { label: 'HaveYouFinalized_Wont,', id: 0, tracking: { name: 'application_status_finalised', info: 'aborted'}},
  { label: 'HaveYouFinalizedSmartApply_Yes,', id: 0, tracking: { name: 'application_status_finalised', info: 'yes'}},
  { label: 'HaveYouFinalizedSmartApply_NotYet,', id: 0, tracking: { name: 'application_status_finalised', info: 'no'}},
  { label: 'HaveYouFinalizedSmartApply_Wont,', id: 0, tracking: { name: 'application_status_finalised', info: 'aborted'}},
  { label: 'HaveYouBeenContacted_YesInterviewPlanned,', id: 0, tracking: { name: 'application_status_contacted', info: 'interview'}},
  { label: 'HaveYouBeenContacted_No,', id: 0, tracking: { name: 'application_status_contacted', info: 'not_contacted'}},
  { label: 'HaveYouBeenContacted_Declined,', id: 0, tracking: { name: 'application_status_contacted', info: 'rejected'}},
  { label: 'DidYouHaveFeedback_Recruited,', id: 0, tracking: { name: 'application_status_recruited', info: 'yes'}},
  { label: 'DidYouHaveFeedback_Declined,', id: 0, tracking: { name: 'application_status_recruited', info: 'no'}},
  { label: 'DidYouHaveFeedback_NotYet', id: 0, tracking: { name: 'application_status_recruited', info: 'not_yet'}},
]

export const META_STATUS_DISPLAYED = [
  { label: 'OnGoing', id: 0, color: 'tw-bg-blue-400'},
  { label: 'Sent', id: 1, color: 'tw-bg-blue-400'},
  { label: 'SeenByRecruiter', id: 2, color: 'tw-bg-purple-400'},
  { label: 'PlannedInterview', id: 3, color: 'tw-bg-purple-400'},
  { label: 'Recruited', id: 4, color: 'tw-bg-green-400'},
  { label: 'Rejected', id: 5, color: 'tw-bg-grey-300'},
  { label: 'Error', id: 6, color: 'tw-bg-error-500'},
  { label: 'Aborted', id: 7, color: 'tw-bg-grey-300'},
]

export const META_STATUS = {
  OnGoing: 0,
  Sent: 1,
  SeenByRecruiter: 2,
  PlannedInterview: 3,
  Recruited: 4,
  Rejected: 5,
  Error: 6,
  Aborted: 7,
}
